import {useNavigate, useParams} from "react-router-dom";
import {useEditQna} from "../hooks/useEditQna";
import {useEffect} from "react";
import moment from "moment";
import {FreedomEditor} from "../../../../components/common/FreedomEditor";
import {useReadTopicType} from "../../faq/hooks";
import {useReadProductGroup} from "../../faq/hooks/useReadProductGroup";
import {useUser} from "../../../../util/userContext/UserContext";

const QuestionState = ["접수", "진행", "완료"];
const QuestionStateCode = ["1", "2", "3"];

export const QnaDetailInput = () => {
    const navigate = useNavigate();
    const {user} = useUser();
    const {data: topicTypeData} = useReadTopicType();
    const {data: groupData} = useReadProductGroup();
    const {id} = useParams();
    const {inputData, setInputData, onChangeInputData, removeFile, UploadUI, handleButtonClick, saveQna} = useEditQna();

    const group = (groupData ?? []).find(g => g.newProductGroupid === inputData?.newProductGroupid);

    useEffect(() => {
        if (topicTypeData && groupData && !inputData?.qnaId)
            setInputData((prev: any) => ({
                ...prev,
                topicTypeIdx: topicTypeData[0]?.idx ?? 0,
                newProductGroupid: groupData[0]?.newProductGroupid ?? '',
            }));
    }, [topicTypeData, groupData]);

    const UserNameAndRegAt = () => {
        if (inputData?.faqId) {
            return `${inputData?.userName} | ${inputData?.regAt}`;
        } else {
            return `${user?.userName} | ${moment().format("YYYY-MM-DD")}`;
        }
    }

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">1:1문의 생성하기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-primary w-100px h-38px"
                                onClick={() => saveQna(inputData)}>저장
                        </button>
                        <button
                            className="btn btn-outline-secondary w-100px h-38px"
                            onClick={() => inputData.qnaId ? navigate(`${process.env.PUBLIC_URL}/support/qna/detail/${inputData.qnaId}`, {replace: true})
                                : navigate(-1)}>
                            취소
                        </button>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                        <tr>
                            <th colSpan={2} style={{width: "12.5%"}}>제목</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={inputData?.title ?? ''}
                                    name={"title"}
                                    onChange={e => onChangeInputData(e)}/>
                            </td>
                        </tr>
                        <tr>
                            <th colSpan={2}>작성자/등록일</th>
                            <td>{UserNameAndRegAt()}</td>
                        </tr>
                        <tr>
                            <th rowSpan={5}>기본정보</th>
                            <th style={{width: "6.5%"}}>유형</th>
                            <td>
                                <select
                                    className="form-select w-150px"
                                    value={inputData?.topicTypeIdx}
                                    name={"topicTypeIdx"}
                                    onChange={e => onChangeInputData(e)}>
                                    {topicTypeData?.map((item: any) => <option
                                        value={item.idx}>{item.codeEntriesName}</option>)}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>제품군</th>
                            <td>
                                <select
                                    className="form-select w-150px"
                                    value={inputData?.newProductGroupid}
                                    name={"newProductGroupid"}
                                    onChange={e => onChangeInputData(e)}>
                                    {groupData?.map((item: any) => <option
                                        value={item.newProductGroupid}>{item.newName}</option>)}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>벤더</th>
                            <td>{group?.productVendor}</td>
                        </tr>
                        <tr>
                            <th>카테고리</th>
                            <td>{group?.productCategory}</td>
                        </tr>
                        <tr>
                            <th>상태</th>
                            <td>
                                <select
                                    disabled={!id}
                                    className="form-select text-success w-150px"
                                    name={"questionState"}
                                    value={QuestionState.includes(inputData?.questionState) ?
                                        QuestionStateCode[QuestionState.indexOf(inputData?.questionState)] : inputData?.questionState}
                                    onChange={(e) => onChangeInputData(e)}>
                                    <option value={"접수"}>접수</option>
                                    {id && <option value={"진행"}>진행</option>}
                                    {id && <option value={"완료"}>완료</option>}
                                </select>
                            </td>
                        </tr>
                        <tr style={{height: "249px"}}>
                            <th colSpan={2}>내용</th>
                            <td className="p-4px" style={{verticalAlign: "top"}}>
                                <FreedomEditor
                                    setValue={setInputData}
                                    value={inputData?.body ?? ''}
                                    fieldName={'body'}/>
                            </td>
                        </tr>
                        <tr>
                            <th colSpan={2}>첨부파일</th>
                            <td>
                                <div className="tbl_files_outer">
                                    {inputData?.fileVOList.length !== 0 && <ul className="list_files">
                                        {(inputData?.fileVOList ?? []).map((item: any) => <li>
                                            <a>{item.fileOrgname}</a>
                                            <button
                                                className="btn btn-link p-0"
                                                onClick={() => removeFile(item.fileKey)}>
                                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"}
                                                     alt=""/>
                                            </button>
                                        </li>)}
                                    </ul>}
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={() => handleButtonClick()}>파일 업로드
                                    </button>
                                    <UploadUI/>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}